import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getForgotPasswordCompleteRegistrationPath = () => urlHelper(`/forgot-password/complete-registration`);
